/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { action } from 'typesafe-actions';
import { EditedCreateExchangeOrder } from './exchange-orders-models';

export const actionTypes = {
  SET_EDITED_EXCHANGE_ORDER: 'ExchangeOrders/SetEditedExchangeOrder',
  SET_SHOULD_VALIDATE: 'ExchangeOrders/SetShouldValidate',
  SET_VALID_DATES: 'ExchangeOrders/SetValidDates',
  SET_INVESTABLE_ACCOUNT_BALANCE: 'ExchangeOrders/SetInvestableAccountBalance',
  SET_INVESTABLE_SECURITY_AMOUNT: 'ExchangeOrders/SetInvestableSecurityAmount',
};

export const actions = {
  setEditedExchangeOrder: (data?: EditedCreateExchangeOrder) =>
    action(actionTypes.SET_EDITED_EXCHANGE_ORDER, data),
  setShouldValidate: (validate: boolean) => action(actionTypes.SET_SHOULD_VALIDATE, validate),
  setValidDates: (dates: string[]) => action(actionTypes.SET_VALID_DATES, dates),
  setInvestableAccountBalance: (balance?: number) => action(actionTypes.SET_INVESTABLE_ACCOUNT_BALANCE, balance),
  setInvestableSecurityAmount: (amount?: number) => action(actionTypes.SET_INVESTABLE_SECURITY_AMOUNT, amount),
};
